import { ErrorLayout as Layout } from '../../../layouts/Error/ErrorLayout';

export const ApiNotRespondingPage = () => {
  return (
    <Layout>
      <div>
        <h1>Connection Failed</h1>
        <p>
          We are unable to connect to the server at this time.
          <br />
          Please try again later.
        </p>
        <button className="btn btn-primary ps-4 pe-4" onClick={() => location.reload()}>
          Retry
        </button>
      </div>
    </Layout>
  );
};
